export default __webpack_public_path__ + "static/media/Ying Ge - Logistics Coordinator.1bbc6200.jpg";